import React, { useMemo } from 'react'
import { ThemeProvider, useTheme } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import { createOrderToCashTheme } from './theme'

export default function withDebtorUI (Component) {
  function DebtorView (props) {
    const isDebtor = useSelector(state => Boolean(state.session && state.session.currentCompany && state.session.currentCompany.isDebtor))
    const parentTheme = useTheme()
    const theme = useMemo(() => ({ ...createOrderToCashTheme(parentTheme), orderToCashDebtor: true }), [parentTheme])

    // Keep the same provider tree on company switches so forms retain their local state.
    // Other company types receive the parent theme without the debtor overrides.
    return <ThemeProvider theme={isDebtor ? theme : parentTheme}><Component {...props} /></ThemeProvider>
  }

  DebtorView.displayName = `DebtorUI(${Component.displayName || Component.name || 'View'})`
  return DebtorView
}
